<template>
  <div class="tools-partners-partners">
    <snow-data-table-header
      v-if="partners.length"
      :add="false"
      :filters="false"
      :datePicker="false"
      @searching="onSearch"
    />

    <div v-if="loading" class="text-center my-9">
      <b-spinner variant="primary" />
    </div>

    <div v-else>
      <!-- descktop area -->
      <snow-data-table :columns="columns" :data="partners">
        <template #no-content-actions>
          <div class="bg-2 rounded-16 p-4 d-flex gap-3">
            <i class="ph ph-clock-countdown fs-32" />
            <div class="d-flex flex-column gap-1">
              <h6 class="text-semibold">Receber um convite</h6>
              <h6 class="text-dark-40">
                Aguarde ser convidado para ajudar a administrar um novo negócio
              </h6>
            </div>
          </div>
        </template>
      </snow-data-table>
    </div>

    <div v-if="!loading" class="d-flex justify-content-end mt-4">
      <snow-paginator
        v-model="page"
        :pagination="pagination"
        @change-page="dispatch"
      />
    </div>

    <responsive-modal v-model="dialog" size="lg">
      <invite-modal v-if="dialog" :item="itemToEdit" @close="dialog = false" />
    </responsive-modal>
  </div>
</template>

<script>
import InviteModal from "./InviteModal";

import { updateArrayItem } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  components: { InviteModal },
  data() {
    return {
      search: "",
      dialog: false,
      loading: false,
      itemToEdit: null,
      page: 1,
      pagination: { count: 0 }
    };
  },
  computed: {
    ...mapState("partnersCenter", ["partners"]),
    columns() {
      return [
        {
          name: "Colaborador",
          field: "user",
          transform: user => user.name
        },
        {
          name: "E-mail",
          field: "user",
          transform: user => user.email
        },
        {
          name: "Perfil",
          field: "perfil",
          transform: (_, item) =>
            item.is_admin ? "Administrador" : item.perfil?.name
        },
        {
          name: "Status",
          field: "is_blocked",
          transform: (_, item) => (item.is_blocked ? "Bloqueado" : "Aprovado"),
          class: (_, item) =>
            item.is_blocked ? "inactive-badge" : "active-badge"
        },
        {
          type: "menu",
          options: this.actions
        }
      ];
    }
  },
  mounted() {
    this.dispatch();
  },
  watch: {
    dialog(v) {
      if (!v) this.itemToEdit = null;
    }
  },
  methods: {
    actions(item) {
      return [
        {
          label: "Editar",
          click: () => this.edit(item)
        },
        ...[
          item.is_blocked
            ? {
                label: "Desbloquear acesso",
                dialog: {
                  text:
                    "Tem certeza que deseja desbloquear o acesso deste colaborador?",
                  icon: "ph ph-prohibit",
                  buttonText: "Sim, desbloquear",
                  action: () => this.block(item),
                  secondaryButtonText: "Não, cancelar"
                }
              }
            : {
                label: "Bloquear acesso",
                dialog: {
                  text:
                    "Tem certeza que deseja bloquear o acesso deste colaborador?",
                  icon: "ph ph-check-circle",
                  buttonText: "Sim, bloquear",
                  action: () => this.block(item),
                  secondaryButtonText: "Não, cancelar"
                }
              }
        ]
      ];
    },
    profile(item) {
      return item.is_admin ? "Administrador" : item.perfil?.name;
    },
    onSearch(text) {
      this.search = text;
      this.dispatch();
    },
    dispatch(offset = null) {
      this.loading = true;
      this.$store
        .dispatch("partnersCenter/getPartners", {
          offset,
          search: this.search
        })
        .then(({ count, next, previous }) => {
          this.pagination = { count, next, previous };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit(item) {
      this.itemToEdit = {
        ...item,
        email: item.user?.email,
        name: item.user?.name,
        perfil_id: item.perfil?.id
      };
      this.dialog = true;
    },
    block(item) {
      this.$store
        .dispatch("partnersCenter/putPartner", {
          id: item.id,
          is_blocked: !item.is_blocked
        })
        .then(data => {
          this.$store.commit(
            "partnersCenter/setPartners",
            updateArrayItem(this.partners, data)
          );
          this.$message.success(
            `Colaborador ${item.is_blocked ? "desbloqueado" : "bloqueado"}.`
          );
        })
        .catch(() => this.$message.error("Erro ao atualizar colaborador"));
    }
  }
};
</script>
